// uReport news shown in the agent Fan Hub (specs/ureport-news-feed).
// Source: `ureport_news` in the AI_RECOMMENDED_FOR_YOU response - raw ureport_news_story rows,
// already filtered by the backend: network page = network + all schools, school page = that school.

export interface FanNewsStory {
  id: string;
  title: string;
  imageUrl: string | null;
  sport: string | null;
  gender: 'male' | 'female' | null;
  publishedAt: string;
  storyUrl: string;
  sourceName: string | null;
}

// Only uReport story pages may be opened in the story popup's iframe.
export const UREPORT_STORY_URL_PREFIX = 'https://stories.ureport.com/';

export function isUreportStoryUrl(url: unknown): url is string {
  return typeof url === 'string' && url.startsWith(UREPORT_STORY_URL_PREFIX);
}

// Raw rows -> card items: drops hidden rows and anything that isn't a uReport story link,
// newest first (the backend already orders them; sorting again keeps the card correct either way).
export function toFanNewsStories(raw: any[] | null | undefined): FanNewsStory[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .filter((row) => row && Number(row.is_hidden) !== 1 && row.title && isUreportStoryUrl(row.story_url))
    .map((row) => ({
      id: String(row.ureport_story_id ?? row.id),
      title: String(row.title),
      imageUrl: row.image_url || null,
      sport: row.sport || null,
      gender: row.gender === 'male' || row.gender === 'female' ? row.gender : null,
      publishedAt: row.published_at,
      storyUrl: row.story_url,
      sourceName: row.ureport_org_name || null,
    }))
    .sort((a, b) => (Date.parse(b.publishedAt) || 0) - (Date.parse(a.publishedAt) || 0));
}

// "MMA · Men's" - skips the parts uReport didn't send.
export function newsMetaLine(story: FanNewsStory): string {
  const gender = story.gender === 'female' ? "Women's" : story.gender === 'male' ? "Men's" : null;
  return [story.sport, gender].filter(Boolean).join(' · ');
}
